import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber10 = () => {
  return (
    <g>
      <path d="m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm-2.1058 11.3649h-1.375v-5.94l-1.65.4063v-1.2212l3.025-.7149zm4.2129.1318c-1.87 0-2.8935-1.6611-2.8935-3.8066 0-2.1562 1.0234-3.8066 2.8935-3.8066s2.8935 1.65 2.8935 3.8066c0 2.1455-1.0234 3.8066-2.8935 3.8066z" />
      <path d="m10.1071 5.2206c-1.0674 0-1.5185 1.1006-1.5185 2.6514s.4512 2.6514 1.5185 2.6514c1.0781 0 1.5293-1.1 1.5293-2.6514s-.4512-2.6514-1.5293-2.6514z" />
    </g>
  );
};

export default withIcon(IconNumber10);
